import { Link } from 'react-router-dom';
import { Users, Home, Battery, Sun } from 'lucide-react';
import type { SystemStats } from '../types';

interface StatsGridProps {
  stats: SystemStats;
}

function formatCapacity(value: number, unit: 'kW' | 'kWh'): string {
  if (value >= 1000) {
    const megaValue = value / 1000;
    const megaUnit = unit === 'kW' ? 'MW' : 'MWh';
    return `${megaValue.toFixed(1)} ${megaUnit}`;
  }
  return `${value.toFixed(1)} ${unit}`;
}

export function StatsGrid({ stats }: StatsGridProps) {
  const items = [
    {
      label: 'Users',
      value: stats.users,
      icon: Users,
      color: 'text-brand-orange',
      bg: 'bg-brand-orange/10 dark:bg-brand-orange/20',
      link: '/admin/users',
    },
    {
      label: 'Total Sites',
      value: stats.sites,
      icon: Home,
      color: 'text-brand-orange',
      bg: 'bg-brand-orange/10 dark:bg-brand-orange/20',
      link: '/admin/sites',
    },
    {
      label: 'Solar Capacity',
      value: formatCapacity(stats.solar_capacity_kw, 'kW'),
      icon: Sun,
      color: 'text-yellow-600 dark:text-yellow-400',
      bg: 'bg-yellow-100 dark:bg-yellow-900/30',
      link: '/admin/sites',
    },
    {
      label: 'Storage Capacity',
      value: formatCapacity(stats.storage_capacity_kwh, 'kWh'),
      icon: Battery,
      color: 'text-brand-orange',
      bg: 'bg-brand-orange/10 dark:bg-brand-orange/20',
      link: '/admin/sites',
    },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
      {items.map((item) => (
        <Link
          key={item.label}
          to={item.link}
          className="card p-4 hover:border-brand-orange transition-colors"
        >
          <div className="flex items-center gap-3">
            <div className={`p-2 rounded-lg ${item.bg}`}>
              <item.icon className={`w-5 h-5 ${item.color}`} />
            </div>
            <div>
              <p className="text-2xl font-bold text-gray-900 dark:text-white">{item.value}</p>
              <p className="text-sm text-gray-500 dark:text-gray-400">{item.label}</p>
            </div>
          </div>
        </Link>
      ))}
    </div>
  );
}
